<body>

<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h1>4<span></span>4</h1>
    </div>
    <h2>Oops! Essa página não existe</h2>
    <p>Pedimos desculpas, mas essa página no momento está indisponivel ou não existe.</p>
    <a [routerLink]="'/news-list'">Voltar para Inicio</a>
  </div>
</div>

</body>
